import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import {
  BaseFpxComponentState,
  BaseFpxDataService,
  BaseFpxFormHelper,
  DynamicFormConfig,
} from "@fpx/core";
import { Subject, takeUntil } from "rxjs";

@Directive()
export class BaseFpxDynamicForm implements OnInit, OnDestroy, AfterViewInit {
  private _formConfig: Array<DynamicFormConfig> = [];
  private _formDataService!: BaseFpxDataService<any>;
  private _formHelper!: BaseFpxFormHelper<BaseFpxComponentState>;
  private _formControlService: Map<string, BaseFpxDataService<any>> = new Map<
    string,
    BaseFpxDataService<any>
  >();
  private _formGroupName!: string;
  private _router: Router;
  private _changeDetectorRef: ChangeDetectorRef;
  private readonly destroy$: Subject<any> = new Subject<any>();
  private _routingParams: any;
  private _formGroup! : FormGroup;
  protected state :  any;

  constructor(_router: Router, _changeDetectorRef: ChangeDetectorRef) {
    this._router = _router;
    this._changeDetectorRef = _changeDetectorRef;
    this._setRoutingParam();
  }

  public getRoutingParam(key: any): any {
    return this._routingParams?.[key] || "";
  }

  private _setRoutingParam() {
    this._routingParams =
      this._router.getCurrentNavigation()?.extras?.queryParams;
    this._formGroupName = this._routingParams?.["serviceTypeId"];
  }

  public setFormGroup(formGroup:FormGroup){
    this._formGroup  = formGroup;
    this._formHelper.doPostInit();
  }

  public setFormState(formState: BaseFpxComponentState){
    this.state = formState
  }

  public get formGroup() : FormGroup {
    return this._formGroup
  }

  async ngOnInit() {
    this.doPreInit();
    this._formHelper.setRoutingParam(this._routingParams);
    this.state = this._formHelper.getState;
    this._formHelper.doPreInit();
  }
  ngOnDestroy(): void {
    this.doDestroy();
    this.destroy$.next(null);
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    this.doPostInit();
  }

  setFormHelper(formHelper: BaseFpxFormHelper<BaseFpxComponentState>) {
    this._formHelper = formHelper;
  }

  setFormDataService(formDataService: BaseFpxDataService<any>) {
    this._formDataService = formDataService;
  }

  addFormControlService(
    formControlName: string,
    formControlService: BaseFpxDataService<any>
  ) {
    this._formControlService.set(
      `${this._formGroupName}${formControlName}`,
      formControlService
    );
  }

  public get formControlService(): Map<string, BaseFpxDataService<any>> {
    return this._formControlService;
  }

  public get formDataService(): BaseFpxDataService<any> {
    return this._formDataService;
  }

  public get formGroupName(): string {
    return this._formGroupName;
  }

  public get formHelper(): BaseFpxFormHelper<BaseFpxComponentState> {
    return this._formHelper;
  }

  public get formConfig(): Array<DynamicFormConfig> {
    return this._formConfig;
  }

  protected doPreInit(): void {}
  protected doPostInit(): void {}
  protected doDestroy(): void {}
}
